import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CNotificationComponent } from './c-notification/c-notification.component';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorDialogComponent } from './c-notification/error-dialog/error-dialog.component';
import { SharedModule } from '../../shared.module';
import { CheckoutErrorDialogComponent } from './c-notification/checkout-error-dialog/checkout-error-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        SharedModule,
        CNotificationComponent, ErrorDialogComponent, CheckoutErrorDialogComponent
    ],
    exports: [CNotificationComponent]
})
export class CNotificationModule { }
